import LobbyLayout from "./LobbyLayout";

export default LobbyLayout;
